export default {"src":"/_next/static/media/slack.f695f89a.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};